import React, { Component } from 'react';
import DockPanel from '../DockPanel/DockPanel';
import Web3 from "web3";
import {Button, Tabs, Tab, Table, Spinner, Card, CardColumns} from "react-bootstrap";
import EnsResolver from "ens-resolver";
import Countdown from 'react-countdown';

import ERC20Resolver from "./ERC20Resolver.js";
import ERC20ApprovalButton from "./ERC20ApprovalButton.js";

import ZoraModuleManager from "../../contracts/Zora/ZoraModuleManager.json";
import ERC721TransferHelper from "../../contracts/Zora/ERC721TransferHelper.json";
import ERC20TransferHelper from "../../contracts/Zora/ERC20TransferHelper.json";
import AsksV1_1 from "../../contracts/Zora/AsksV1_1.json";
import OffersV1 from "../../contracts/Zora/OffersV1.json";
import ReserveAuctionCoreErc20 from "../../contracts/Zora/ReserveAuctionCoreErc20.json";

import DOLLARS from "../../contracts/Dollars.json";

import './ZoraModal.css';

class ZoraModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      zoraModalLoading: false,
      
      zoraERC721TransferHelper: null,
      zoraERC20TransferHelper: null,
      zoraModuleManager: null,

      zoraAsks: null,
      zoraOffers: null,
      zoraAuctions: null,

      isZoraAsksApproved: false,
      isZoraOffersApproved: false,
      isZoraAuctionsApproved: false,

      zoraLoadError: null,

      askForToken: null,
      validAskForToken: false,
      validOfferCount: 0,
      auctionForToken: null,
      validAuctionForToken: false,

      selectedOfferId: null,
      selectedOfferMaker: null, 
      selectedOfferCurrency: null, 
      selectedOfferAmount: null, 

      selectedToken: "0x0000000000000000000000000000000000000000",
      customTokenMode: false
    }

    this.updateSeq = 0;
    this._isMounted = false;
  }

  setupZoraContracts = async () => {
    // Load account
    const web3 = new Web3(this.props.contract.currentProvider);
    this.web3 = web3;
    if (!web3 || !web3.eth) return;

    // Network ID
    const networkId = await web3.eth.net.getId();

    let deployedNetwork = null;
    let zoraModuleManager = null;
    let zoraERC721TransferHelper = null;
    let zoraERC20TransferHelper = null;
    let zoraAsks = null;
    let zoraOffers = null;
    let zoraAuctions = null;
    let dollars = null;

    deployedNetwork = ZoraModuleManager.networks[networkId];
    if(deployedNetwork) {
        zoraModuleManager = new web3.eth.Contract(
        ZoraModuleManager.abi,
        deployedNetwork && deployedNetwork.address,
      );
    }

    deployedNetwork = ERC721TransferHelper.networks[networkId];
    if(deployedNetwork) {
        zoraERC721TransferHelper = new web3.eth.Contract(
        ERC721TransferHelper.abi,
        deployedNetwork && deployedNetwork.address,
      );
    }

    deployedNetwork = ERC20TransferHelper.networks[networkId];
    if(deployedNetwork) {
        zoraERC20TransferHelper = new web3.eth.Contract(
        ERC20TransferHelper.abi,
        deployedNetwork && deployedNetwork.address,
      );
    }

    deployedNetwork = AsksV1_1.networks[networkId];
    if(deployedNetwork) {
        zoraAsks = new web3.eth.Contract(
        AsksV1_1.abi,
        deployedNetwork && deployedNetwork.address,
      );
    }

    deployedNetwork = OffersV1.networks[networkId];
    if(deployedNetwork) {
        zoraOffers = new web3.eth.Contract(
        OffersV1.abi,
        deployedNetwork && deployedNetwork.address,
      );
    }

    // ReserveAuctionCoreErc20
    deployedNetwork = ReserveAuctionCoreErc20.networks[networkId];
    if(deployedNetwork) {
        zoraAuctions = new web3.eth.Contract(
        ReserveAuctionCoreErc20.abi,
        deployedNetwork && deployedNetwork.address,
      );
    }
    
    deployedNetwork = DOLLARS.networks[networkId];
    if(deployedNetwork) {
        dollars = new web3.eth.Contract(
        DOLLARS.abi,
        deployedNetwork && deployedNetwork.address,
      );
    }


    const selectedToken = "0x0000000000000000000000000000000000000000";

    await new Promise((resolve) => {
      this.setState({
        zoraModuleManager,
        zoraERC721TransferHelper,
        zoraERC20TransferHelper,
        zoraAsks,
        zoraOffers,
        zoraAuctions,
        dollars,
        networkId,
        selectedToken
      }, resolve);
    });

  }

  /**
   * Read the project's current Zora listings.
   *
   * This used to replay every Ask, Offer and Auction event from block 0. Any
   * wallet RPC with a range limit refuses that outright — MetaMask's caps
   * eth_getLogs at 10,000 blocks and the chain is past 25 million — and the
   * rejection was caught and discarded, so a marketplace that could not be read
   * looked exactly like a marketplace with nothing listed.
   *
   * Zora publishes current state through view functions, so the listings are
   * read per token instead. The work is bounded by the size of the project
   * rather than the length of the chain, no range limit applies, and the result
   * is the live state rather than a replay that is only as good as the slice of
   * history that happened to come back.
   */
  getZoraLogs = async (tokenIdsForProjectId = [], updateId) => {
    if (updateId && updateId !== this.updateSeq) {
      return;
    }

    const tokenIds = (Array.isArray(tokenIdsForProjectId) ? tokenIdsForProjectId : []).filter(
      (id) => id !== null && id !== undefined
    );
    const { zoraAsks, zoraOffers, zoraAuctions } = this.state;
    const tokenContract = this.props.contract && this.props.contract.options
      ? this.props.contract.options.address
      : null;

    this.setState({ zoraLogsModalLoading: true, zoraLoadError: null, loadingDescription: '' });

    if (!tokenContract || !zoraAsks || !zoraOffers || !zoraAuctions) {
      this.setState({
        zoraLogsModalLoading: false,
        zoraLoadError: 'The Zora marketplace contracts are not available on this network.',
      });
      return;
    }

    const ZERO = '0x0000000000000000000000000000000000000000';
    const isEmpty = (address) => !address || String(address).toLowerCase() === ZERO;
    // offersForNFT is a plain public array, so its length can only be found by
    // walking it until the call reverts. The ceiling stops a malformed response
    // from turning into an unbounded loop.
    const MAX_OFFERS_PER_TOKEN = 64;

    const asksOverviewData = {};
    const offersOverviewData = {};
    const auctionsOverviewData = {};
    let failures = 0;

    const readToken = async (tokenId) => {
      try {
        const ask = await zoraAsks.methods.askForNFT(tokenContract, tokenId).call();
        if (ask && !isEmpty(ask[0])) {
          asksOverviewData[tokenId] = { ask: { ask, tokenId }, tokenId };
        }
      } catch (error) {
        failures++;
      }

      try {
        const auction = await zoraAuctions.methods.auctionForNFT(tokenContract, tokenId).call();
        if (auction && !isEmpty(auction[0])) {
          auctionsOverviewData[tokenId] = { auction: { auction, tokenId }, tokenId };
        }
      } catch (error) {
        failures++;
      }

      for (let index = 0; index < MAX_OFFERS_PER_TOKEN; index++) {
        let offerId;
        try {
          offerId = await zoraOffers.methods.offersForNFT(tokenContract, tokenId, index).call();
        } catch (error) {
          // Reverts once the index passes the end of the array: not a failure.
          break;
        }
        if (offerId === null || offerId === undefined) break;
        try {
          const offer = await zoraOffers.methods.offers(tokenContract, tokenId, offerId).call();
          if (offer && !isEmpty(offer[0])) {
            offersOverviewData[offerId] = { offer: { offer, id: offerId, tokenId }, tokenId };
          }
        } catch (error) {
          failures++;
        }
      }
    };

    // A thousand tokens read one after another would take minutes, so a small
    // pool runs concurrently. It is deliberately modest: a wallet's RPC will
    // rate limit a burst, and being throttled is slower than being patient.
    const CONCURRENCY = 8;
    let cursor = 0;
    let completed = 0;
    const worker = async () => {
      while (cursor < tokenIds.length) {
        const mine = cursor++;
        if (updateId && updateId !== this.updateSeq) return;
        await readToken(tokenIds[mine]);
        completed++;
        if (this._isMounted && (completed % 10 === 0 || completed === tokenIds.length)) {
          const percent = Math.round((completed / tokenIds.length) * 100);
          this.setState({ loadingDescription: `reading listings ${percent}% ...` });
        }
      }
    };
    await Promise.all(
      Array.from({ length: Math.min(CONCURRENCY, tokenIds.length) }, () => worker())
    );

    if (updateId && updateId !== this.updateSeq) {
      return;
    }

    // Edition numbers are what the overview displays, and only listed tokens
    // need one, so these lookups are proportional to the listings found.
    const addEditionId = async (collection, tokenIdOf) => {
      for (const key of Object.keys(collection)) {
        try {
          const editionId = await this.props.contract.methods
            .tokenIdToEditionId(tokenIdOf(collection[key]))
            .call();
          collection[key] = { ...collection[key], editionId, projectId: this.props.projectId };
        } catch (error) {
          failures++;
        }
      }
    };
    await addEditionId(asksOverviewData, (entry) => entry.ask.tokenId);
    await addEditionId(offersOverviewData, (entry) => entry.offer.tokenId);
    await addEditionId(auctionsOverviewData, (entry) => entry.auction.tokenId);

    if (updateId && updateId !== this.updateSeq) {
      return;
    }
    if (!this._isMounted) {
      return;
    }

    this.setState({
      zoraLogsModalLoading: false,
      loadingDescription: '',
      asksOverviewData,
      offersOverviewData,
      auctionsOverviewData,
      // Reported rather than swallowed: an unreadable marketplace and an empty
      // one look identical otherwise, and they mean very different things to
      // someone checking whether their edition is listed.
      zoraLoadError: failures
        ? `${failures} listing ${failures === 1 ? 'lookup' : 'lookups'} failed, so this list may be incomplete. Your wallet's RPC may be rate limiting.`
        : null,
    });
  }


  updateAndNotify = async () => {
    const updateId = ++this.updateSeq;
    this.setState({zoraModalLoading: true})
    const { contract, tokenId } = this.props;
    if (!contract) {
      if (this._isMounted) {
        this.setState({zoraModalLoading: false});
      }
      return;
    }

    // TODO: Implement or remove.
    let tokenIdsForProjectId = [];
    if(this.props.projectId) {
      tokenIdsForProjectId = await contract.methods.getTokenIdsForProjectId(this.props.projectId).call();
      // console.log("ZoraModal tokenIdsForProjectId: ", tokenIdsForProjectId)
    }
    if (updateId !== this.updateSeq) {
      return;
    }

    // Get Zora Logs
    if(!this.props.tokenId) { await this.getZoraLogs(tokenIdsForProjectId, updateId); }
    if (updateId !== this.updateSeq) {
      return;
    }

    // Zora Transfer Helpers

    let isZoraERC721TransferHelperApproved = null;
    if(this.state.zoraERC721TransferHelper) { 
      if(this.props.account) {
        isZoraERC721TransferHelperApproved = await contract.methods.isApprovedForAll(this.props.account, this.state.zoraERC721TransferHelper.options.address).call()
        // console.log("isZoraERC721TransferHelperApproved: ", isZoraERC721TransferHelperApproved);
      }
    }

    let isZoraERC20TransferHelperApproved = null;
    if(this.state.zoraERC20TransferHelper && this.state.dollars) { 
      if(this.props.account) {
        let allowance = await this.state.dollars.methods.allowance(this.props.account, this.state.zoraERC20TransferHelper.options.address).call()
        isZoraERC20TransferHelperApproved = (allowance > 0)
        // console.log("isZoraERC20TransferHelperApproved: ", allowance, isZoraERC20TransferHelperApproved);
      }
    }

    // Zora Asks

    let isZoraAsksApproved = this.state.isZoraAsksApproved;
    if(this.state.zoraAsks && this.state.zoraModuleManager && !isZoraAsksApproved) { 
      if(this.props.account) {
        isZoraAsksApproved = await this.state.zoraModuleManager.methods.isModuleApproved(this.props.account, this.state.zoraAsks.options.address).call()
        // console.log("isZoraAsksApproved: ", isZoraAsksApproved);
      }
    }

    let askForToken = null;
    let validAskForToken = false;
    if(this.state.zoraAsks && tokenId) { 
      askForToken = await this.state.zoraAsks.methods.askForNFT(contract.options.address, tokenId).call()
      if(askForToken.seller !== '0x0000000000000000000000000000000000000000' && askForToken.seller === this.props.ownerOfSelectedEdition) {
        validAskForToken = true;
      }
      // console.log("zora askForToken, validAskForToken: ", askForToken, validAskForToken);
    }

    // Zora Offers

    let isZoraOffersApproved = this.state.isZoraOffersApproved;
    if(this.state.zoraOffers && this.state.zoraModuleManager && !isZoraOffersApproved) { 
      if(this.props.account) {
        isZoraOffersApproved = await this.state.zoraModuleManager.methods.isModuleApproved(this.props.account, this.state.zoraOffers.options.address).call()
        // console.log("isZoraOffersApproved: ", isZoraOffersApproved);
      }
    }

    // offersForNFT#
    // Returns an array of offerIds for a specific ERC-721 token.
    // ERC-721 tokenAddress => ERC-721 tokenID => Offer IDs

    let offersForNFT = [];
    let nextOffer = null;
    let offerCount = 0;
    if(this.state.zoraOffers && tokenId) {
      do {
        
        try {
          nextOffer = await this.state.zoraOffers.methods.offersForNFT(contract.options.address, tokenId, offerCount).call()
        } catch (error) { 
          nextOffer = null
        }
        
        if (nextOffer !== null) { 
          offersForNFT.push(nextOffer) 
        } else {
           nextOffer = null;
        }
        
        offerCount++;
      } while(nextOffer !== null)
    }
    // console.log("zora offersForNFT: ", offersForNFT);

    // offers#
    // Returns the metadata for an offer.
    //  ERC-721 Token Address => ERC-721 tokenID => offerID => Offer
    //  mapping(address => mapping(uint256 => mapping(uint256 => Offer))) public offers

    let offerDetails = []
    let offerDetailsNo = null;
    let validOfferCount = 0;

    for(let offer in offersForNFT) { 
      try {
        offerDetailsNo = await this.state.zoraOffers.methods.offers(contract.options.address, tokenId, offersForNFT[offer]).call()
      } catch(error) { 
        offerDetailsNo = null
      }

      if (offerDetailsNo !== null && offerDetailsNo.maker !== "0x0000000000000000000000000000000000000000") { 
        offerDetails.push({offerId: offersForNFT[offer], offer: offerDetailsNo})
        validOfferCount++; 
      } else {
        offerDetailsNo = null;
      }

      // console.log("zora offerDetails, validOfferCount: ", offerDetails, validOfferCount);
    }

    // Zora Auctions

    //ReserveAuctionCoreErc20
    let isZoraAuctionsApproved = this.state.isZoraAuctionsApproved;
    if(this.state.zoraAuctions && this.state.zoraModuleManager && !isZoraAuctionsApproved) { 
      if(this.props.account) {
        isZoraAuctionsApproved = await this.state.zoraModuleManager.methods.isModuleApproved(this.props.account, this.state.zoraAuctions.options.address).call()
        // console.log("isZoraAuctionsApproved: ", isZoraAuctionsApproved);
      }
    }

    let auctionForToken = null;
    let validAuctionForToken = false;
    if(this.state.zoraAuctions && tokenId) { 
      auctionForToken = await this.state.zoraAuctions.methods.auctionForNFT(contract.options.address, tokenId).call()
      if(auctionForToken.seller !== '0x0000000000000000000000000000000000000000') {
        validAuctionForToken = true;
      }
      // console.log("zora auctionForToken: ", auctionForToken, validAuctionForToken);
    }

    if (updateId !== this.updateSeq) {
      return;
    }
    if (!this._isMounted) {
      return;
    }
    this.setState({
      zoraModalLoading: false,
      isZoraERC721TransferHelperApproved,
      isZoraERC20TransferHelperApproved,
      isZoraAsksApproved,
      isZoraOffersApproved,
      isZoraAuctionsApproved,
      askForToken,
      offersForNFT,
      offerDetails,
      auctionForToken,
      validAskForToken,
      validOfferCount,
      validAuctionForToken,
      tokenIdsForProjectId
    })
  }

  componentDidMount = async () => {
    this._isMounted = true;
    await this.setupZoraContracts();
    await this.updateAndNotify();
  }

  componentDidUpdate = async (prevProps) => {
    if (prevProps.tokenId !== this.props.tokenId) {
      await this.updateAndNotify();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.updateSeq += 1;
  }

  handleTransactionError = (error) => {
    this.setState({zoraModalLoading: false})
  }

  // ==== ZORA TRANSFER HELPERS

  approveZoraERC721TransferHelperOnIA = () => {
    this.setState({zoraModalLoading: true})
    this.props.contract.methods.setApprovalForAll(this.state.zoraERC721TransferHelper.options.address, true).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("approveZoraERC721TransferHelperOnIA receipt: ", receipt)
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  approveZoraERC20TransferHelperOnDOLLARS = () => {
    this.setState({zoraModalLoading: true})
    this.state.dollars.methods.approve(this.state.zoraERC20TransferHelper.options.address, '115792089237316195423570985008687907853269984665640564039457584007913129639935').send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("approveZoraERC20TransferHelperOnToken receipt: ", receipt)
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  /// ==== ZORA ASKS MODULE FUNCTIONS 

  approveZoraAsksModule = () => {
    this.setState({zoraModalLoading: true})
    this.state.zoraModuleManager.methods.setApprovalForModule(this.state.zoraAsks.options.address, true).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("approveZoraAsksModule receipt: ", receipt)
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  zoraCreateAsk = (askPrice, askCurrency) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    let sellerFundsRecipient = this.props.account;
    let findersFeeBps = 0;
    this.state.zoraAsks.methods.createAsk(tokenContract, tokenId, askPrice, askCurrency, sellerFundsRecipient, findersFeeBps).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("zoraCreateAsk receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  zoraSetAskPrice = (askPrice, askCurrency) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    this.state.zoraAsks.methods.setAskPrice(tokenContract, tokenId, askPrice, askCurrency).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("zoraSetAskPrice receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  zoraCancelAsk = () => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    this.state.zoraAsks.methods.cancelAsk(tokenContract, tokenId).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("zoraCancelAsk receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  zoraFillAsk = (fillCurrency, fillAmount) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    let finder = "0x0000000000000000000000000000000000000000";
    if(fillCurrency === "0x0000000000000000000000000000000000000000") {
      this.state.zoraAsks.methods.fillAsk(tokenContract, tokenId, fillCurrency, fillAmount, finder).send({from: this.props.account, value: fillAmount})
      .once('receipt', async (receipt) => {
        // console.log("zoraFillAsk receipt: ", receipt)
        await this.updateAndNotify()
        this.setState({zoraModalLoading: false})
      })
      .on('error', this.handleTransactionError)
    } else {
      this.state.zoraAsks.methods.fillAsk(tokenContract, tokenId, fillCurrency, fillAmount, finder).send({from: this.props.account})
      .once('receipt', async (receipt) => {
        // console.log("zoraFillAsk receipt: ", receipt)
        await this.updateAndNotify()
        this.setState({zoraModalLoading: false})
      })
      .on('error', this.handleTransactionError)
    }
  }

  /// END ZORA ASKS MODULE FUNCTIONS

  /// ==== ZORA OFFERS MODULE FUNCTIONS 

  setSelectedOffer = async (selectedOfferId, selectedOfferMaker, selectedOfferCurrency, selectedOfferAmount) => {
    this.setState({selectedOfferId, selectedOfferMaker, selectedOfferCurrency, selectedOfferAmount})
  }

  setSelectedToken = async (selectedToken) => {
    // console.log("zora Selected Token: ", selectedToken);
    const isKnown = this.getKnownTokens().some(t => t.address.toLowerCase() === selectedToken.toLowerCase());
    this.setState({selectedToken, customTokenMode: !isKnown})
  }

  getKnownTokens = () => {
    const ETH = "0x0000000000000000000000000000000000000000";
    const tokens = [
      { label: "ETH", address: ETH },
      { label: "DOLLARS", address: this.state.dollars ? this.state.dollars.options.address : null },
    ];
    if (this.state.networkId === 1) {
      tokens.push({ label: "FASTCASH", address: "0xcA5228D1fe52D22db85E02CA305cddD9E573D752" });
    }
    tokens.push(
      { label: "DAI", address: "0x6B175474E89094C44Da98b954EedeAC495271d0F" },
      { label: "USDC", address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48" },
      { label: "USDT", address: "0xdAC17F958D2ee523a2206206994597C13D831ec7" },
      { label: "WETH", address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2" },
    );
    return tokens.filter(t => t.address);
  }

  handleTokenSelectChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      this.setState({ customTokenMode: true });
    } else {
      this.setState({ customTokenMode: false, selectedToken: value });
    }
  }

  approveZoraOffersModule = () => {
    this.setState({zoraModalLoading: true})
    this.state.zoraModuleManager.methods.setApprovalForModule(this.state.zoraOffers.options.address, true).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("approveZoraOffersModule receipt: ", receipt)
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

   /*
  /// FUNCTIONS
  createOffer#
  Creates an offer for a specific NFT which can be made in either ETH or an ERC-20 token and returns the offerId of the newly created offer.

  ZORA takes custody of the amount until either the offer is filled or canceled

  The user must first approve the ERC-20 Transfer Helper if the offer currency is an ERC-20 token

  No approvals are needed if the offer currency is ETH
  function createOffer(
      address _tokenContract,
      uint256 _tokenId,
      address _currency, //ERC-20 token address or address(0) for ETH
      uint256 _amount,
      uint16 _findersFeeBps
  ) returns (uint256)
  */
  zoraCreateOffer = (currency, amount) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    let findersFeeBps = 0;
    if(currency === "0x0000000000000000000000000000000000000000") {
      this.state.zoraOffers.methods.createOffer(tokenContract, tokenId, currency, amount, findersFeeBps).send({from: this.props.account, value: amount})
      .once('receipt', async (receipt) => {
        // console.log("zoraCreateOffer receipt: ", receipt)
        await this.updateAndNotify()
        this.setState({zoraModalLoading: false})
      })
      .on('error', this.handleTransactionError)
    } else {
      this.state.zoraOffers.methods.createOffer(tokenContract, tokenId, currency, amount, findersFeeBps).send({from: this.props.account})
      .once('receipt', async (receipt) => {
        // console.log("zoraCreateOffer receipt: ", receipt)
        await this.updateAndNotify()
        this.setState({zoraModalLoading: false})
      })
      .on('error', this.handleTransactionError)
    }
  }

  /*
  fillOffer#
  Fills a given offer for an owned NFT, in exchange for ETH/ERC-20 tokens.

  finder: The address of the party that helped match the offer to the buyer
  The finder can be set to address(0) if no address is known
  function fillOffer(
      address _tokenContract,
      uint256 _tokenId,
      uint256 _offerId,
      address _currency,
      uint256 _amount,
      address _finder
  )*/
  zoraFillOffer = (offerId, currency, amount) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    let finder = "0x0000000000000000000000000000000000000000";
    this.state.zoraOffers.methods.fillOffer(tokenContract, tokenId, offerId, currency, amount, finder).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("zoraFillOffer receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  /*
  setOfferAmount#
  Updates either the price, currency, or both for a given offer.
  Increasing the amount requires that the user provide more collateral
  Decreasing the amount will refund the difference back to the offer maker address
  Updating the currency to an ERC-20 will require that the user approve the ERC-20 Transfer Helper if they haven't already approved that token.
  function setOfferAmount(
      address _tokenContract,
      uint256 _tokenId,
      uint256 _offerId,
      address _currency,
      uint256 _amount
  )
  */
  zoraSetOfferAmount = (offerId, currency, amount) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    if(currency === "0x0000000000000000000000000000000000000000") {
      this.state.zoraOffers.methods.setOfferAmount(tokenContract, tokenId, offerId, currency, amount).send({from: this.props.account, value: amount})
      .once('receipt', async (receipt) => {
        // console.log("zoraSetOfferAmount receipt: ", receipt)
        await this.updateAndNotify()
        this.setState({zoraModalLoading: false})
      })
      .on('error', this.handleTransactionError)
    } else {
      this.state.zoraOffers.methods.setOfferAmount(tokenContract, tokenId, offerId, currency, amount).send({from: this.props.account})
      .once('receipt', async (receipt) => {
        // console.log("zoraSetOfferAmount receipt: ", receipt)
        await this.updateAndNotify()
        this.setState({zoraModalLoading: false})
      })
      .on('error', this.handleTransactionError)
    }
  }
  /*
  cancelOffer#
  Cancels and refunds the given offer.

  function cancelOffer(
      address _tokenContract,
      uint256 _tokenId,
      uint256 _offerId
  )
  */
  zoraCancelOffer = (offerId) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    this.state.zoraOffers.methods.cancelOffer(tokenContract, tokenId, offerId).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("zoraCancelOffer receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  /// ===== START ZORA AUCTIONS (CoreERC20ReserveAuction) 

  approveZoraAuctionsModule = () => {
    this.setState({zoraModalLoading: true})
    this.state.zoraModuleManager.methods.setApprovalForModule(this.state.zoraAuctions.options.address, true).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("approveZoraAuctionsModule receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  /*
  Creates an auction for a given ERC-721 NFT. There can only be one auction at a time for an NFT.
  function createAuction(
    address _tokenContract,
    uint256 _tokenId,
    uint256 _duration,
    uint256 _reservePrice,
    address _sellerFundsRecipient,
    uint256 _startTime,
    address _bidCurrency
  ) */
  zoraCreateAuction = (duration, reservePrice, bidCurrency) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    let startTime = 0;
    let sellerFundsRecipient = this.props.account;
    this.state.zoraAuctions.methods.createAuction(tokenContract, tokenId, duration, reservePrice, sellerFundsRecipient, startTime, bidCurrency).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("zoraCreateAuction receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  /*
  Updates the auction reserve price for a given NFT
  function setAuctionReservePrice(
      address _tokenContract,
      uint256 _tokenId,
      uint256 _reservePrice
  )*/
  zoraSetAuctionReservePrice = (reservePrice) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    this.state.zoraAuctions.methods.setAuctionReservePrice(tokenContract, tokenId, reservePrice).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("zoraSetAuctionReservePrice receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  /*
  cancelAuction#
  Cancels the auction for a given NFT.
  function cancelAuction(address _tokenContract, uint256 _tokenId)
  */
  zoraCancelAuction = () => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    this.state.zoraAuctions.methods.cancelAuction(tokenContract, tokenId).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("zoraCancelAuction receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  /*
  createBid#
  Places a bid on the auction for a given NFT. The bid percentage difference must be greater than or equal to 10% of the previous bid.

  function createBid(
      address _tokenContract,
      uint256 _tokenId,
      uint256 _amount
  )
  */
  zoraCreateBid = (amount) => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    if(this.state.auctionForToken && this.state.auctionForToken.currency === "0x0000000000000000000000000000000000000000") {
      this.state.zoraAuctions.methods.createBid(tokenContract, tokenId, amount).send({from: this.props.account, value: amount})
      .once('receipt', async (receipt) => {
        // console.log("zoraCreateBid receipt: ", receipt)
        await this.updateAndNotify()
        this.setState({zoraModalLoading: false})
      })
      .on('error', this.handleTransactionError)
    } else {
      this.state.zoraAuctions.methods.createBid(tokenContract, tokenId, amount).send({from: this.props.account})
      .once('receipt', async (receipt) => {
        // console.log("zoraCreateBid receipt: ", receipt)
        await this.updateAndNotify()
        this.setState({zoraModalLoading: false})
      })
      .on('error', this.handleTransactionError)
    }
  }

  /*
  settleAuction#
  Ends the auction for a given NFT by sending the NFT to the highest bidder and the funds to the seller. Note, this module honors royalty payouts.
  function settleAuction(address _tokenContract, uint256 _tokenId) 
  */
  zoraSettleAuction = () => {
    this.setState({zoraModalLoading: true})
    let tokenContract = this.props.contract.options.address;
    let tokenId = this.props.tokenId;
    this.state.zoraAuctions.methods.settleAuction(tokenContract, tokenId).send({from: this.props.account})
    .once('receipt', async (receipt) => {
      // console.log("zoraSettleAuction receipt: ", receipt)
      await this.updateAndNotify()
      this.setState({zoraModalLoading: false})
    })
    .on('error', this.handleTransactionError)
  }

  /// END ZORA CoreERC20 Reserve Auction

 render() {
    const { isZoraModalOpen, closeZoraModal,
            ownerOfSelectedEdition, account,
            platform, contract,
            tokenId, projectId, editionId, projectTokens, projects,
          } = this.props;

    const { 
      isZoraERC721TransferHelperApproved,
      isZoraAsksApproved, isZoraOffersApproved, isZoraAuctionsApproved
    } = this.state;


    const loadingInsert =  <>
                            <p></p>
                            <Card><Card.Body>
                            <div align="center"><Card.Title>Loading ZORA Market Data ...</Card.Title></div>
                            <div align="center"><Spinner animation="grow" /></div>
                            </Card.Body></Card>
                            <p></p>
                            </>

    /// ASKS TABS

    const approveZoraERC721TransferHelperForm = <form onSubmit={(event) => {
                                                  event.preventDefault()
                                                  this.approveZoraERC721TransferHelperOnIA()
                                                  }}>
                                                  <input
                                                    id="submit"
                                                    type="submit"
                                                    className="btn btn-block btn-warning"
                                                    value="Approve Zora ERC721 Transfer Helper on Immutables.art"
                                                  />
                                                </form>

    const approveZoraAsksForm = <form onSubmit={(event) => {
                                event.preventDefault()
                                this.approveZoraAsksModule()
                                }}>
                                <input
                                  id="submit"
                                  type="submit"
                                  className="btn btn-block btn-warning"
                                  value="Approve Zora Asks Module on Zora Module Manager"
                                />
                              </form>

    const zoraCreateAskForm = <>
                                
                                    <Card>
                                      <Card.Body>
                                        <Card.Title>
                                          Create a fixed price listing.
                                        </Card.Title>
                                      <form onSubmit={(event) => {
                                        event.preventDefault()
                                        let amountInWei = Web3.utils.toWei(event.target.amount.value);
                                        this.zoraCreateAsk(
                                          amountInWei,
                                          event.target.token.value
                                        )
                                      }}>
                                      <p></p>
                                      <Card.Subtitle className="mb-2 text-muted">Currency:</Card.Subtitle>
                                      <Card.Title>
                                        <select style={{width: '100%'}}
                                          onChange={this.handleTokenSelectChange}
                                          value={this.state.customTokenMode ? "custom" : this.state.selectedToken}
                                        >
                                          {this.getKnownTokens().map(t =>
                                            <option key={t.address} value={t.address}>{t.label}</option>
                                          )}
                                          <option value="custom">Custom ERC20 Address</option>
                                        </select>
                                        {this.state.customTokenMode && (
                                          <input type="text" style={{width: '100%', marginTop: '8px'}}
                                            placeholder="0x..." onBlur={e => this.setSelectedToken(e.target.value)} />
                                        )}
                                        <input type="hidden" id="token" value={this.state.selectedToken} />
                                      </Card.Title>
                                      <Card.Subtitle className="mb-2 text-muted" style={{wordBreak: 'break-all'}}>
                                        <ERC20Resolver
                                          key="selectedERC20TokenResolver"
                                          tokenAddress={this.state.selectedToken} />
                                      </Card.Subtitle>
                                      <p></p>
                                      <Card.Subtitle className="mb-2 text-muted">Amount:</Card.Subtitle>
                                      <Card.Title>
                                        <input
                                          type="text"
                                          style={{width: '100%'}} 
                                          id="amount" required
                                        />
                                      </Card.Title>
                                      <p></p>
                                      <input
                                        id="submit"
                                        type="submit"
                                        className="btn btn-block btn-primary"
                                        value="List NFT for a Fixed Price"
                                      />
                                      </form>
                                    </Card.Body>
                                  </Card>
                            
                              </>

    const zoraSetAskPriceForm = <>
                            
                                <Card>
                                  <Card.Body>
                                <Card.Title>Update the asking price and currency.</Card.Title>
                                <form onSubmit={(event) => {
                                  event.preventDefault()
                                  let amountInWei = Web3.utils.toWei(event.target.amount.value);
                                  this.zoraSetAskPrice(
                                    amountInWei,
                                    event.target.token.value
                                  )
                                }}>
                                  <p></p>
                                  <Card.Subtitle className="mb-2 text-muted">Currency:</Card.Subtitle>
                                  <Card.Title>
                                    <select style={{width: '100%'}}
                                      onChange={this.handleTokenSelectChange}
                                      value={this.state.customTokenMode ? "custom" : this.state.selectedToken}
                                    >
                                      {this.getKnownTokens().map(t =>
                                        <option key={t.address} value={t.address}>{t.label}</option>
                                      )}
                                      <option value="custom">Custom ERC20 Address</option>
                                    </select>
                                    {this.state.customTokenMode && (
                                      <input type="text" style={{width: '100%', marginTop: '8px'}}
                                        placeholder="0x..." onBlur={e => this.setSelectedToken(e.target.value)}
                                        defaultValue={(this.state.askForToken) ? this.state.askForToken.askCurrency : ""} />
                                    )}
                                    <input type="hidden" id="token" value={this.state.selectedToken} />
                                  </Card.Title>
                                  <Card.Subtitle className="mb-2 text-muted" style={{wordBreak: 'break-all'}}>
                                    <ERC20Resolver
                                    key="selectedERC20TokenResolver"
                                    tokenAddress={this.state.selectedToken} />
                                  </Card.Subtitle>
                                  <p></p>
                                  <Card.Subtitle className="mb-2 text-muted">Amount:</Card.Subtitle>
                                  <Card.Title>
                                    <input
                                    type="text" 
                                    style={{width: '100%'}} 
                                    id="amount" 
                                    required
                                    defaultValue={(this.state.askForToken) ? Web3.utils.fromWei(this.state.askForToken.askPrice, "ether") : ""}
                                  />
                                  </Card.Title>
                                  <p></p>
                                  <input
                                    id="submit"
                                    type="submit"
                                    className="btn btn-block btn-primary"
                                    value="Update Ask"
                                  />
                                  </form>
                                </Card.Body>
                              </Card>
                            
                          </>

    const zoraCancelAskForm = <>
                            
                                <Card>
                                  <Card.Body>
                                <form onSubmit={(event) => {
                                  event.preventDefault()
                                  this.zoraCancelAsk()
                              }}>
                              <input
                                id="submit"
                                type="submit"
                                className="btn btn-block btn-danger"
                                value="Cancel Offered Asking Price"
                              />
                              </form>
                              </Card.Body>
                              </Card>
                           
                              </>

    const zoraFillAskForm = <>
                             <Card>
                                    <Card.Body>
                                      <form onSubmit={(event) => {
                                        event.preventDefault()
                                        let amountInWei = Web3.utils.toWei(event.target.fillAmount.value);
                                        this.zoraFillAsk(
                                          event.target.fillCurrency.value,
                                          amountInWei
                                        )
                                      }}>

                                      <Card.Subtitle className="mb-2 text-muted">Amount:</Card.Subtitle>
                                      <Card.Title>
                                        {(this.state.askForToken) ? Web3.utils.fromWei(this.state.askForToken.askPrice, "ether") : ""}
                                        &nbsp;
                                        <ERC20Resolver
                                          key={`askForToken-${tokenId}`}
                                          tokenAddress={(this.state.askForToken) ? this.state.askForToken.askCurrency : ""}
                                        />
                                        </Card.Title>
                                        <Card.Title>
                                        <p></p>
                                        <ERC20ApprovalButton
                                          key={this.state.selectedToken}
                                          style={{width: '100%'}}
                                          account={this.props.account}
                                          tokenAddress={this.state.selectedToken}
                                          spenderName="Zora ERC20TransferHelper"
                                          spenderAddress={(this.state.zoraERC20TransferHelper)?this.state.zoraERC20TransferHelper.options.address:""}
                                          approvedAmount='115792089237316195423570985008687907853269984665640564039457584007913129639935'
                                        />
                                        <input 
                                          type="hidden"
                                          id="fillCurrency" required 
                                          defaultValue={(this.state.askForToken) ? this.state.askForToken.askCurrency : ""}
                                        />
                                        <input
                                          type="hidden"
                                          id="fillAmount" 
                                          required
                                          defaultValue={(this.state.askForToken) ? Web3.utils.fromWei(this.state.askForToken.askPrice, "ether") : ""}
                                        />
                                      </Card.Title>
                                        <p></p>
                                        <input
                                          id="submit"
                                          type="submit"
                                          className="btn btn-block btn-primary"
                                          value="Buy it Now"
                                        />
                                      </form>

                                    </Card.Body>
                                  </Card>
                            </>

    const approveZoraAsksTabInsert = <>
                                        {(!isZoraERC721TransferHelperApproved || !isZoraAsksApproved) ? (
                                          <Card className="mb-3">
                                            <Card.Body>
                                            <Card.Subtitle className="mb-2 text-muted">Approvals Required</Card.Subtitle>
                                            <p style={{fontSize: '0.9em'}}>
                                              Before you can list an edition for sale, Zora's smart contracts need permission to act on your behalf.
                                              These are standard ERC721 approvals — each is a one-time on-chain transaction per contract.
                                              You are not transferring ownership; you are authorizing Zora's contracts to facilitate trades when you choose to execute them.
                                            </p>
                                            <ol>
                                          {(!isZoraERC721TransferHelperApproved) ? (
                                            <>
                                            <li><strong>ERC721 Transfer Helper</strong> — allows Zora to transfer your NFT to a buyer when a sale completes. Without this, Zora cannot move the token on your behalf.</li>
                                            {approveZoraERC721TransferHelperForm}
                                            </>
                                          ) : ("")}

                                        {(!isZoraAsksApproved) ? (
                                            <>
                                            <li><strong>Asks Module</strong> — allows the Zora Asks contract to create and manage fixed-price listings for your edition.</li>
                                            {approveZoraAsksForm}
                                            </>
                                          ) : ("")}
                                          </ol>
                                            </Card.Body>
                                          </Card>
                                        ) : ("")}
                                        </>
    
    const zoraAsksTabForOwner =   <Tab eventKey="zora_asks" title="List for a Fixed Price">
                                    {(this.state.zoraModalLoading) ? (
                                      <>{loadingInsert}</>
                                    ) : (
                                      <>
                                      <p></p>
                                        {approveZoraAsksTabInsert}
                                        <p></p>
                                          {(isZoraERC721TransferHelperApproved && isZoraAsksApproved) ? (
                                            (this.state.askForToken && 
                                              this.state.askForToken.seller !== '0x0000000000000000000000000000000000000000' &&
                                              this.state.askForToken.seller === ownerOfSelectedEdition) ? (
                                                <>
                                                <p></p>
                                                {zoraSetAskPriceForm}
                                                <p></p>
                                                {zoraCancelAskForm}
                                                <p></p>
                                                </>
                                              ) : (
                                                (this.state.askForToken && 
                                                  this.state.askForToken.seller !== '0x0000000000000000000000000000000000000000' &&
                                                  this.state.askForToken.seller !== ownerOfSelectedEdition) ? (
                                                    <>
                                                    A prior seller created an ask
                                                    {zoraCancelAskForm}
                                                    </>
                                                  ) : (
                                                    <>
                                                    {zoraCreateAskForm}
                                                    </>
                                                  )
                                              )
                                          ) : ("")}
                                        <p></p>
                                        </>
                                    )}
                                  </Tab>

    const zoraAsksTabForBuyer = <Tab eventKey="zora_asks" title="Buy it Now" onClick={() => this.setSelectedToken(this.state.askForToken.askCurrency)}>
                                  
                                  {(this.state.zoraModalLoading) ? (
                                    <>{loadingInsert}</>
                                  ) : (
                                    <>
                                    <p></p>
                                      {
                                      // If there is an Ask
                                      // TODO: Add token approval?
                                      (this.state.askForToken && 
                                        this.state.askForToken.seller !== '0x0000000000000000000000000000000000000000' &&
                                        this.state.askForToken.seller === ownerOfSelectedEdition) ? (
                                        <>
                                        <p></p>
                                        {zoraFillAskForm}
                                        </>
                                      ) : (
                                        "There is no current asking price.  Consider making an Offer."
                                      )}
                                    <p></p>
                                    </>
                                  )}
                                  </Tab>

    const zoraAsksTab = (ownerOfSelectedEdition === account) ? (zoraAsksTabForOwner) : (zoraAsksTabForBuyer)

    /// OFFERS TABS

    const approveZoraOffersForm = <form onSubmit={(event) => {
                                      event.preventDefault()
                                      this.approveZoraOffersModule()
                                    }}>
                                    <input
                                      id="submit"
                                      type="submit"
                                      className="btn btn-block btn-warning"
                                      value="Approve Zora Offers Module on Zora Module Manager"
                                    />
                                  </form>

  const approveZoraOffersTabInsert = <>
                                    {(!isZoraOffersApproved) ? (
                                      <Card className="mb-3">
                                        <Card.Body>
                                        <Card.Subtitle className="mb-2 text-muted">Approval Required</Card.Subtitle>
                                        <p style={{fontSize: '0.9em'}}>
                                          Before you can make or accept offers, Zora's Offers contract needs your permission.
                                          This is a one-time on-chain approval that authorizes the Offers module to hold funds in escrow on your behalf and to facilitate the exchange when an offer is accepted.
                                        </p>
                                        <ol>
                                        <li><strong>Offers Module</strong> — allows the Zora Offers contract to manage offers and escrow funds for this marketplace.</li>
                                        {approveZoraOffersForm}
                                        </ol>
                                        </Card.Body>
                                      </Card>
                                    ) : ("")}
                                  </>

    const zoraCreateOfferForm = <>
                                    <Card>
                                    <Card.Body>
                                    <Card.Title>  
                                    Create an offer with any token, or ETH.
                                    </Card.Title>
                                    <form onSubmit={(event) => {
                                      event.preventDefault()
                                      let amountInWei = Web3.utils.toWei(event.target.amount.value);
                                      //zoraCreateOffer = (currency, amount)
                                      this.zoraCreateOffer(
                                        event.target.token.value,
                                        amountInWei
                                      )
                                    }}>
                                      <p></p>
                                        <Card.Subtitle className="mb-2 text-muted">Currency:</Card.Subtitle>
                                        <Card.Title>
                                          <select style={{width: '100%'}}
                                            onChange={this.handleTokenSelectChange}
                                            value={this.state.customTokenMode ? "custom" : this.state.selectedToken}
                                          >
                                            {this.getKnownTokens().map(t =>
                                              <option key={t.address} value={t.address}>{t.label}</option>
                                            )}
                                            <option value="custom">Custom ERC20 Address</option>
                                          </select>
                                          {this.state.customTokenMode && (
                                            <input type="text" style={{width: '100%', marginTop: '8px'}}
                                              placeholder="0x..." onBlur={e => this.setSelectedToken(e.target.value)} />
                                          )}
                                          <input type="hidden" id="token" value={this.state.selectedToken} />
                                        </Card.Title>
                                        <p></p>
                                        <ERC20ApprovalButton
                                          key={this.state.selectedToken}
                                          account={this.props.account}
                                          tokenAddress={this.state.selectedToken}
                                          spenderName="Zora ERC20TransferHelper"
                                          spenderAddress={(this.state.zoraERC20TransferHelper)?this.state.zoraERC20TransferHelper.options.address:""}
                                          approvedAmount='115792089237316195423570985008687907853269984665640564039457584007913129639935'
                                        />
                                        <p></p>
                                        <Card.Subtitle className="mb-2 text-muted">Amount:</Card.Subtitle>
                                        <Card.Title>
                                          <input type="text" 
                                            style={{width: '100%'}} 
                                            id="amount" 
                                            required
                                          />
                                        </Card.Title>
                                      <p></p>
                                      <input
                                        id="submit"
                                        type="submit"
                                        className="btn btn-block btn-primary"
                                        value="Make an Offer"
                                      />
                                      </form>
                                      </Card.Body>
                                      </Card>
                                </>

    const zoraSetOfferAmountForm = <>
                            {
                              (this.state.selectedOfferMaker && this.state.selectedOfferMaker === this.props.account) ? (
                                
                                  <Card>
                                    <Card.Body>
                                    <Card.Title>
                                      Update an offer with any token, or ETH.
                                      </Card.Title>
                                  <form onSubmit={(event) => {
                                    event.preventDefault()
                                    let amountInWei = Web3.utils.toWei(event.target.offerAmount.value);
                                    this.zoraSetOfferAmount(
                                      event.target.offerId.value,
                                      event.target.offerCurrency.value,
                                      amountInWei
                                    )
                                  }}>
                                    <p></p>
                                    <input type="hidden" style={{width: '100%'}} id="offerId" required 
                                      defaultValue={(this.state.selectedOfferId) ? this.state.selectedOfferId : ""}/>
                                  <Card.Subtitle className="mb-2 text-muted">Currency:</Card.Subtitle>
                                  <Card.Title>
                                    <select style={{width: '100%'}}
                                      onChange={this.handleTokenSelectChange}
                                      value={this.state.customTokenMode ? "custom" : this.state.selectedToken}
                                    >
                                      {this.getKnownTokens().map(t =>
                                        <option key={t.address} value={t.address}>{t.label}</option>
                                      )}
                                      <option value="custom">Custom ERC20 Address</option>
                                    </select>
                                    {this.state.customTokenMode && (
                                      <input type="text" style={{width: '100%', marginTop: '8px'}}
                                        placeholder="0x..." onBlur={e => this.setSelectedToken(e.target.value)}
                                        defaultValue={(this.state.selectedOfferCurrency) ? this.state.selectedOfferCurrency : ""} />
                                    )}
                                    <input type="hidden" id="offerCurrency" value={this.state.selectedToken} />
                                  </Card.Title>
                                  <p></p>
                                  <ERC20ApprovalButton
                                    key={`zoraSetOfferAmountForm-${this.state.selectedOfferCurrency}`}
                                    account={this.props.account}
                                    tokenAddress={this.state.selectedOfferCurrency}
                                    spenderName="Zora ERC20TransferHelper"
                                    spenderAddress={(this.state.zoraERC20TransferHelper)?this.state.zoraERC20TransferHelper.options.address:""}
                                    approvedAmount='115792089237316195423570985008687907853269984665640564039457584007913129639935'
                                  />
                                  <p></p>
                                  <Card.Subtitle className="mb-2 text-muted">Amount:</Card.Subtitle>
                                  <Card.Title>
                                  <input 
                                    type="text" 
                                    style={{width: '100%'}} 
                                    id="offerAmount" 
                                    required
                                    defaultValue={(this.state.selectedOfferAmount) ? Web3.utils.fromWei(this.state.selectedOfferAmount, "ether") : ""}
                                  />
                                  </Card.Title>
                                <p></p>
                                <input
                                  id="submit"
                                  type="submit"
                                  className="btn btn-block btn-warning"
                                  value={`Update Offer (Offer ID ${this.state.selectedOfferId})`}
                                />
                                </form>
                                </Card.Body>
                                </Card>
                              
                            ):("")
                          }
                          </>
                            
    const zoraCancelOfferForm = <>
                              {
                                (this.state.selectedOfferMaker && this.state.selectedOfferMaker === this.props.account) ? (
                                  
                                    <Card>
                                      <Card.Body>
                                    <form onSubmit={(event) => {
                                      event.preventDefault()                                      
                                      this.zoraCancelOffer(
                                        event.target.offerId.value
                                      )
                                    }}>
                                    <input type="hidden" style={{width: '100%'}} id="offerId" required 
                                    defaultValue={(this.state.selectedOfferId) ? this.state.selectedOfferId : ""}/>
                                    <input
                                      id="submit"
                                      type="submit"
                                      className="btn btn-block btn-danger"
                                      value={`Cancel Offer (Offer ID ${this.state.selectedOfferId})`}
                                    />
                                    </form>
                                    </Card.Body>
                                    </Card>
                                  
                              ):("")
                            }
                            </>

    const zoraFillOfferForm = <>
                              {
                                (this.state.selectedOfferMaker && 
                                  this.props.ownerOfSelectedEdition === this.props.account &&
                                  this.state.selectedOfferMaker !== this.props.account) ? (
                                
                                  <Card>
                                    <Card.Body>
                                  <form onSubmit={(event) => {
                                    event.preventDefault()
                                    let amountInWei = Web3.utils.toWei(event.target.offerAmount.value);
                                    
                                    this.zoraFillOffer(
                                      event.target.offerId.value,
                                      event.target.offerCurrency.value,
                                      amountInWei
                                    )
                                  }}>
                                    <Card.Subtitle className="mb-2 text-muted">Offer ID:</Card.Subtitle>
                                    <Card.Title>
                                      {(this.state.selectedOfferId) ? this.state.selectedOfferId : ""}
                                        <input type="hidden" id="offerId" required 
                                      defaultValue={(this.state.selectedOfferId) ? this.state.selectedOfferId : ""}/>
                                    </Card.Title>
                                    <Card.Subtitle className="mb-2 text-muted">Amount:</Card.Subtitle>
                                    <Card.Title style={{wordBreak: 'break-all'}}>
                                      {(this.state.selectedOfferAmount) ? Web3.utils.fromWei(this.state.selectedOfferAmount, "ether") : ""}
                                      &nbsp;
                                      <ERC20Resolver 
                                        key="selectedERC20TokenResolver" 
                                        tokenAddress={this.state.selectedToken} />
                                      <input 
                                        type="hidden"
                                        id="offerAmount" required
                                        defaultValue={(this.state.selectedOfferAmount) ? Web3.utils.fromWei(this.state.selectedOfferAmount, "ether") : ""}
                                        />
                                      <input 
                                        type="hidden" 
                                        id="offerCurrency" 
                                        required 
                                        defaultValue={(this.state.selectedOfferCurrency) ? this.state.selectedOfferCurrency : ""}/>     
                                    </Card.Title>                             
                                <p></p>
                                <input
                                  id="submit"
                                  type="submit"
                                  className="btn btn-block btn-success"
                                  value="Accept Offer"
                                />
                                </form>
                                </Card.Body>
                                </Card>
                              
                              ) : ("")
                            }
                            </>

    let zoraOffersList =  (this.state.offersForNFT && this.state.validOfferCount > 0) ? (
                            <Card>
                              <Card.Body>
                                <Card.Subtitle>
                                  You can select an active offer from the list to perform actions on the offer.
                                  If you are a potential buyer, you can cancel or update the offer.
                                  If you are the owner, you can accept the offer.
                                </Card.Subtitle>
                                <p></p>
                              <Table striped bordered hover responsive size="sm">
                                <thead>
                                  <tr>
                                    <th>Offer ID</th>
                                    <th>Maker</th>
                                    <th>Amount</th>
                                    <th>Currency</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    (this.state.offerDetails ) ? (
                                      this.state.offerDetails.map((offerDetailsNo,i) =>(
                                        (offerDetailsNo.offer.maker !== "0x0000000000000000000000000000000000000000") ? (
                                          <tr key={i} onClick={() => this.setSelectedOffer(offerDetailsNo.offerId, offerDetailsNo.offer.maker, offerDetailsNo.offer.currency, offerDetailsNo.offer.amount)}>
                                            <td>{offerDetailsNo.offerId}</td>
                                            <td><EnsResolver lookup={offerDetailsNo.offer.maker}/>&nbsp;
                                                ({offerDetailsNo.offer.maker})</td>
                                            <td>{(offerDetailsNo.offer.amount) ? Web3.utils.fromWei(offerDetailsNo.offer.amount, "ether") : ("")}</td>
                                            <td><ERC20Resolver tokenAddress={offerDetailsNo.offer.currency}/></td>
                                          </tr>
                                        ) : ("")
                                      ))
                                    ) : ("")
                                      }
                                </tbody>
                                </Table>
                                </Card.Body>
                              </Card>
                              ) : (
                                <Card>
                                  <Card.Body>
                                    <Card.Title>There are no active offers.</Card.Title>
                                  </Card.Body>
                                </Card>
                              )

    const zoraOffersTabForOwner = <Tab eventKey="zora_offers" title="Offers">
                                    {(this.state.zoraModalLoading) ? (
                                      <>{loadingInsert}</>
                                    ) : (
                                      <>
                                      <p></p>
                                      {approveZoraOffersTabInsert}
                                      <p></p>
                                      {zoraOffersList}
                                      <p></p>
                                      {zoraFillOfferForm}
                                      <p></p>
                                      </>
                                    )}
                                  </Tab>

    const zoraOffersTabForBuyer = <Tab eventKey="zora_offers" title="Make Offers">
                                    {(this.state.zoraModalLoading) ? (
                                      <>{loadingInsert}</>
                                    ) : (
                                      <>
                                      <p></p>
                                      {approveZoraOffersTabInsert}
                                      <p></p>
                                      {zoraOffersList}
                                      <p></p>
                                      {zoraCreateOfferForm}
                                      <p></p>
                                      {zoraSetOfferAmountForm}
                                      <p></p>
                                      {zoraCancelOfferForm}
                                      <p></p>
                                      </>
                                    )}
                                  </Tab>

    const zoraOffersTab = (ownerOfSelectedEdition === account) ? (zoraOffersTabForOwner) : (zoraOffersTabForBuyer)

    /// AUCTIONS

    let now = new Date()
    let auctionEndTime = (this.state.auctionForToken && this.state.auctionForToken.firstBidTime > 0) ? (
                            new Date(
                              (parseInt(this.state.auctionForToken.firstBidTime) + parseInt(this.state.auctionForToken.duration))*1000
                            ) 
                          ): (
                            now
                          );
    var auctionRunning = ((auctionEndTime > 0) && (now <= auctionEndTime));

    const approveZoraAuctionsForm = <form onSubmit={(event) => {
                                    event.preventDefault()
                                    this.approveZoraAuctionsModule()
                                    }}>
                                    <input
                                      id="submit"
                                      type="submit"
                                      className="btn btn-block btn-warning"
                                      value="Approve Zora Auctions Module on Zora Module Manager"
                                    />
                                  </form>

    const approveZoraAuctionsTabInsertERC721 = <>
                                    {(!isZoraERC721TransferHelperApproved) ? (
                                      <Card className="mb-3">
                                        <Card.Body>
                                        <Card.Subtitle className="mb-2 text-muted">Transfer Approval Required</Card.Subtitle>
                                        <p style={{fontSize: '0.9em'}}>
                                          Zora needs permission to transfer your NFT to the winning bidder when an auction settles.
                                          This is a standard ERC721 approval — a one-time on-chain transaction that does not transfer ownership.
                                        </p>
                                        <ul>
                                        <li><strong>ERC721 Transfer Helper</strong> — allows Zora to transfer your NFT to the auction winner upon settlement.</li>
                                        {approveZoraERC721TransferHelperForm}
                                        </ul>
                                        </Card.Body>
                                      </Card>
                                    ) : ("")}
                                    </>

    const approveZoraAuctionsTabInsertModule = <>
                                  {(!isZoraAuctionsApproved) ? (
                                    <Card className="mb-3">
                                      <Card.Body>
                                      <Card.Subtitle className="mb-2 text-muted">Module Approval Required</Card.Subtitle>
                                      <p style={{fontSize: '0.9em'}}>
                                        The Zora Auctions contract needs your permission to create and manage reserve auctions for your edition.
                                        This is a one-time on-chain approval.
                                      </p>
                                      <ul>
                                      <li><strong>Auctions Module</strong> — allows the Zora Reserve Auction contract to manage auction creation, bidding, and settlement.</li>
                                      {approveZoraAuctionsForm}
                                      </ul>
                                      </Card.Body>
                                    </Card>
                                  ) : ("")}
                                  </>

    const zoraCreateAuctionForm = <>
                                  {
                                    (this.state.auctionForToken && this.state.auctionForToken.seller === "0x0000000000000000000000000000000000000000") ? (
                                      
                                        <Card>
                                        <Card.Body>
                                        <Card.Title>Create an auction. You can modify or cancel before a bid is placed.</Card.Title>
                                        <form onSubmit={(event) => {
                                          event.preventDefault()
                                          let durationInSeconds = event.target.duration.value * 86400;
                                          let amountInWei = Web3.utils.toWei(event.target.reservePrice.value);
                                          this.zoraCreateAuction(
                                            durationInSeconds,
                                            amountInWei,
                                            event.target.bidCurrency.value
                                          )
                                        }}>
                                          <p></p>
                                          <Card.Subtitle className="mb-2 text-muted">Duration (days):</Card.Subtitle>
                                          <Card.Title>
                                            <input type="number" style={{width: '100%'}} id="duration" required 
                                            defaultValue="1"/>
                                          </Card.Title>
                                          <Card.Subtitle className="mb-2 text-muted">Reserve Price:</Card.Subtitle>
                                          <Card.Title>
                                              <input type="text" style={{width: '100%'}} id="reservePrice" required
                                            defaultValue="0"/>
                                            </Card.Title>
                                        
                                          <Card.Subtitle className="mb-2 text-muted">Bid Currency:</Card.Subtitle>
                                          <Card.Title>
                                            <select style={{width: '100%'}}
                                              onChange={this.handleTokenSelectChange}
                                              value={this.state.customTokenMode ? "custom" : this.state.selectedToken}
                                            >
                                              {this.getKnownTokens().map(t =>
                                                <option key={t.address} value={t.address}>{t.label}</option>
                                              )}
                                              <option value="custom">Custom ERC20 Address</option>
                                            </select>
                                            {this.state.customTokenMode && (
                                              <input type="text" style={{width: '100%', marginTop: '8px'}}
                                                placeholder="0x..." onBlur={e => this.setSelectedToken(e.target.value)} />
                                            )}
                                            <input type="hidden" id="bidCurrency" value={this.state.selectedToken} />
                                          </Card.Title>
                                          <Card.Subtitle className="mb-2 text-muted" style={{wordBreak: 'break-all'}}>
                                            <ERC20Resolver
                                              key="selectedERC20TokenResolver"
                                              tokenAddress={this.state.selectedToken} />
                                          </Card.Subtitle>
                                        
                                      <p></p>
                                      <input
                                        id="submit"
                                        type="submit"
                                        className="btn btn-block btn-primary"
                                        value="Create Reserve Auction"
                                      />
                                      </form>
                                      </Card.Body>
                                      </Card>
                                    
                                  ) : ("")
                                }
                                </>

    const zoraUpdateReserveAuctionForm = <>
                                {
                                  (this.state.auctionForToken && this.state.auctionForToken.seller === ownerOfSelectedEdition) ? (
                                   
                                      <Card>
                                        <Card.Body>
                                          <Card.Title>
                                          You can update the reserve price until someone places a first bid.
                                          </Card.Title>
                                      <form onSubmit={(event) => {
                                        event.preventDefault()
                                        let amountInWei = Web3.utils.toWei(event.target.reservePrice.value);
                                        this.zoraSetAuctionReservePrice(
                                          amountInWei
                                        )
                                      }}>
                                        <p></p>
                                        <Card.Subtitle className="mb-2 text-muted">Reserve Price:</Card.Subtitle>
                                        <Card.Title>
                                          <input 
                                          type="text" 
                                          style={{width: '100%'}} 
                                          id="reservePrice" 
                                          required
                                          defaultValue={(this.state.auctionForToken) ? Web3.utils.fromWei(this.state.auctionForToken.reservePrice, "ether") : ""}/>
                                        </Card.Title>
                                        <Card.Subtitle className="mb-2 text-muted">
                                          <ERC20Resolver 
                                            key={`auctionCurrencyERC20TokenResolver-${tokenId}`} 
                                            tokenAddress={this.state.auctionForToken.currency} />
                                        </Card.Subtitle>
                                    <p></p>
                                    <input
                                      id="submit"
                                      type="submit"
                                      className="btn btn-block btn-warning"
                                      value="Update Reserve Auction"
                                    />
                                    </form>
                                    </Card.Body>
                                    </Card>
                                  
                                ) : ("")
                                }
                                </>

    const zoraCancelAuctionForm = <>
                                  {
                                    (this.state.auctionForToken && this.state.auctionForToken.seller === ownerOfSelectedEdition) ? (
                                     
                                        <Card>
                                        <Card.Body>
                                        <Card.Title>You can cancel the auction until someone places the first bid.</Card.Title>
                                        <form onSubmit={(event) => {
                                          event.preventDefault()                                      
                                          this.zoraCancelAuction()
                                        }}>
                                        <input
                                          id="submit"
                                          type="submit"
                                          className="btn btn-block btn-danger"
                                          value={`Cancel Auction`}
                                        />
                                        </form>
                                        </Card.Body>
                                        </Card>
                                      
                                  ):("")
                                }
                                
                                </>

    const zoraSettleAuctionForm = <>
                                  {
                                    (this.state.auctionForToken && 
                                      this.state.auctionForToken.firstBidTime > 0 &&
                                      this.state.auctionForToken.seller !== '0x0000000000000000000000000000000000000000') ? (
                                      
                                        <Card bg={(auctionRunning) ? 'danger' : 'success'}>
                                          <Card.Body>
                                        <div align="center" style={{fontSize: 'larger', color: '#ffffff'}}>
                                        <Countdown date={(parseInt(this.state.auctionForToken.firstBidTime) + parseInt(this.state.auctionForToken.duration))*1000}>
                                          <>
                                            <form onSubmit={(event) => {
                                              event.preventDefault()                                      
                                              this.zoraSettleAuction()
                                            }}>
                                            <input
                                              id="submit"
                                              type="submit"
                                              className="btn btn-block btn-success"
                                              value={`Settle Auction`}
                                            />
                                            </form>
                                          </>
                                        </Countdown>
                                        </div>
                                        </Card.Body>
                                        </Card>
                                      
                                  ):("")
                                  }
                                  </>

    const zoraAuctionInformation = <>
    {
          (this.state.auctionForToken && this.state.auctionForToken.seller !== '0x0000000000000000000000000000000000000000') ? (
            <>
            <Card>
              <Card.Body>
                <Card.Subtitle className="mb-2 text-muted">Seller:</Card.Subtitle>
                <Card.Title style={{wordBreak: 'break-all'}}>
                  <EnsResolver 
                          key={`auctionSeller-${tokenId}-${this.state.auctionForToken.seller}`} 
                          lookup={this.state.auctionForToken.seller}/>&nbsp;
                          ({this.state.auctionForToken.seller})
                </Card.Title>
                <Card.Subtitle className="mb-2 text-muted">Auction Duration:</Card.Subtitle>
                <Card.Title>
                  {(this.state.auctionForToken) ? String(parseInt(this.state.auctionForToken.duration) / (60*60*24)): ""} day(s)
                </Card.Title>
                <Card.Subtitle className="mb-2 text-muted">Reserve Price:</Card.Subtitle>
                <Card.Title style={{wordBreak: 'break-all'}}>
                  {(this.state.auctionForToken) ? Web3.utils.fromWei(this.state.auctionForToken.reservePrice, "ether") : ""}
                  &nbsp;
                  <ERC20Resolver 
                    key={`auctionCurrencyERC20TokenResolver-${tokenId}`} 
                    tokenAddress={this.state.auctionForToken.currency}/>
                </Card.Title>
              </Card.Body>
            </Card>

            
            {(this.state.auctionForToken && this.state.auctionForToken.highestBidder !== '0x0000000000000000000000000000000000000000') ? (
              <>
              <p></p>
              <Card bg={(this.state.auctionForToken.highestBidder === this.props.account) ? 'success' : 'warning'}>
                <Card.Body>
                  <Card.Subtitle className="mb-2 text-muted">Highest Bidder:</Card.Subtitle>
                  <Card.Title style={{wordBreak: 'break-all'}}>
                    <EnsResolver 
                      key={`auctionHighestBidder-${tokenId}-${this.state.auctionForToken.highestBidder}`} 
                      lookup={this.state.auctionForToken.highestBidder}/>&nbsp;
                      ({this.state.auctionForToken.highestBidder})
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">Highest Bid:</Card.Subtitle>
                  <Card.Title>
                    {(this.state.auctionForToken) ? Web3.utils.fromWei(this.state.auctionForToken.highestBid, "ether") : ""}
                    &nbsp;
                    <ERC20Resolver 
                    key={`auctionCurrencyERC20TokenResolverShort-${tokenId}`} 
                    tokenAddress={this.state.auctionForToken.currency} 
                    short={true}/>
                  </Card.Title>
                </Card.Body>
              </Card>
              </>
            ) : ("")}
          </>
    ) : ("")}
    </>

    const zoraCreateBidForm = <>
                                {
                                  (this.state.auctionForToken && auctionRunning &&
                                    this.state.auctionForToken.seller !== '0x0000000000000000000000000000000000000000' &&
                                    this.state.auctionForToken.seller !== this.props.account &&
                                    this.state.auctionForToken.highestBidder !== this.props.account) ? (

                                      
                                        <Card>
                                          <Card.Body>
                                          <Card.Title>
                                            Place a new bid.
                                            It must meet the reserve or be 10% higher than the highest bid.  
                                            The first bid will start the auction.
                                          </Card.Title>

                                        <form onSubmit={(event) => {
                                          event.preventDefault()
                                          let amountInWei = Web3.utils.toWei(event.target.amount.value);
                                          this.zoraCreateBid(
                                            amountInWei
                                          )
                                        }}>
                                        <p></p>
                                        <Card.Subtitle className="mb-2 text-muted">Amount:</Card.Subtitle>
                                        <Card.Title>
                                          <input 
                                          type="text" 
                                          style={{width: '100%'}} 
                                          id="amount"
                                          required
                                            defaultValue={(this.state.auctionForToken.highestBid > 0) ? 
                                              (String(1.1 * parseFloat(Web3.utils.fromWei(this.state.auctionForToken.highestBid, "ether")))
                                                ) : (
                                                  Web3.utils.fromWei(this.state.auctionForToken.reservePrice, "ether")
                                                )
                                            }
                                            />
                                          </Card.Title>
                                          <p></p>
                                          <ERC20Resolver 
                                            key={`auctionCurrencyERC20TokenResolver-${tokenId}`} 
                                            tokenAddress={this.state.auctionForToken.currency}/>
                                          <p></p>
                                          <ERC20ApprovalButton
                                            key={`auctionCurrencyERC20TokenButton-${tokenId}`}
                                            account={this.props.account}
                                            tokenAddress={this.state.auctionForToken.currency}
                                            spenderName="Zora ERC20TransferHelper"
                                            spenderAddress={(this.state.zoraERC20TransferHelper)?this.state.zoraERC20TransferHelper.options.address:""}
                                            approvedAmount='115792089237316195423570985008687907853269984665640564039457584007913129639935'
                                          />
                                          <p></p>
                                          <input
                                            id="submit"
                                            type="submit"
                                            className="btn btn-block btn-primary"
                                            value="Place a Bid"
                                          />
                                          </form>
                                          </Card.Body>
                                          </Card>
                                      
                                  ):("")
                                }
                                </>

    const zoraAuctionsTabForOwner = <Tab eventKey="zora_sell_with_auction" title="Auction">
                                    {(this.state.zoraModalLoading) ? (
                                       <>{loadingInsert}</>
                                      ) : (
                                        <>
                                        <p></p>
                                        {approveZoraAuctionsTabInsertERC721}
                                        {approveZoraAuctionsTabInsertModule}
                                        <p></p>
                                        {zoraAuctionInformation}
                                        <p></p>
                                        {zoraSettleAuctionForm}
                                        <p></p>
                                        {zoraCreateAuctionForm}
                                        <p></p>
                                        {zoraUpdateReserveAuctionForm}
                                        <p></p>
                                        {zoraCancelAuctionForm}
                                        <p></p>
                                        </>
                                    )}
                                    </Tab>
                                    
    
    const zoraAuctionsTabForBidder = <Tab eventKey="zora_bid_with_auction" title="Auction">
                                     {(this.state.zoraModalLoading) ? (
                                        <>{loadingInsert}</>
                                      ) : (
                                        <>
                                        <p></p>
                                        {approveZoraAuctionsTabInsertModule}
                                        <p></p>
                                        {zoraAuctionInformation}
                                        <p></p>
                                        {zoraSettleAuctionForm}
                                        <p></p>
                                        {zoraCreateBidForm}
                                        <p></p>
                                        </>
                                     )}
                                     </Tab>
                                  
    const zoraAuctionsTab = (ownerOfSelectedEdition === account) ? (zoraAuctionsTabForOwner) : (zoraAuctionsTabForBidder)
    
    let showAsks = ((this.state.validAskForToken || (ownerOfSelectedEdition === account)) && !(this.state.validAuctionForToken && this.state.auctionForToken.firstBidTime > 0));
    let showOffers = (((ownerOfSelectedEdition !== account) || ((this.state.validOfferCount > 0) && (ownerOfSelectedEdition === account))) && !(this.state.validAuctionForToken && this.state.auctionForToken.firstBidTime > 0));
    let showAuctions = (this.state.validAuctionForToken || (ownerOfSelectedEdition === account));
    
    let modalTitle = (projects && projects.length > 0 && projectId !== null && editionId !== null) ? (
                        `zora: ${projects[projectId-1].name} # ${editionId}`
                      ) : (
                        `zora: ${projects[projectId-1].name}`
                      )
    
    
    const overviewAsksTab = <Tab eventKey="zora_asks_overview" title="Asks">
    <p></p>
    <Card>
      <Card.Body>
        <Card.Title>
          Asks Overview
        </Card.Title>
        <CardColumns>
        {
          (this.state.asksOverviewData && !(Object.keys(this.state.asksOverviewData).length === 0)) ? (
            Object.keys(this.state.asksOverviewData).map((k,i) =>(
              
                <Card key={i} 
                bg={(this.props.account === this.state.asksOverviewData[k].ask.ask[0]) ? `warning` : `light`}
                style={{cursor: 'zoom-in'}} onClick={e => this.props.setSelectedEdition(this.state.asksOverviewData[k].editionId)}>
                  <Card.Header as="h5">
                    {projects[projectId-1].name} # {this.state.asksOverviewData[k].editionId}
                  </Card.Header>
                  <Card.Body>
                  <Card.Subtitle className="mb-2 text-muted" >
                    Seller:
                  </Card.Subtitle>
                  <Card.Title>
                    <EnsResolver lookup={this.state.asksOverviewData[k].ask.ask[0]}/>&nbsp;
                    <span className="mb-2 text-muted" style={{fontSize: 'xx-small'}}>({this.state.asksOverviewData[k].ask.ask[0]})</span>
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted" >
                  Asking Price:
                  </Card.Subtitle>
                  <Card.Title>
                  {Web3.utils.fromWei(this.state.asksOverviewData[k].ask.ask[4], "ether")}&nbsp;
                    <ERC20Resolver 
                      key={`AsksOverviewERC20TokenResolverShort-${this.state.asksOverviewData[k].tokenId}`} 
                      tokenAddress={this.state.asksOverviewData[k].ask.ask[2]}
                      short={true}
                    />
                  </Card.Title>
                  </Card.Body>
                </Card>
            
            ))) : (
              <Card>
                  <Card.Body>
                  <Card.Title>
                    {this.state.zoraLoadError ? 'Could not read asks' : 'No Current Asks'}
                  </Card.Title>
                  </Card.Body>
                </Card>
            )
        }
        </CardColumns>
      </Card.Body>
    </Card>
    </Tab>

    const overviewOffersTab = <Tab eventKey="zora_offers_overview" title="Offers">
      <p></p>
                          <Card>
                            <Card.Body>
                              <Card.Title>
                                Offers Overview
                              </Card.Title>
                              <CardColumns>
                              {
                                (this.state.offersOverviewData && !(Object.keys(this.state.offersOverviewData).length === 0)) ? (
                                  Object.keys(this.state.offersOverviewData).map((k,i) =>(
                                    
                                      <Card key={i} 
                                        bg={(this.props.account === this.state.offersOverviewData[k].offer.offer[0]) ? `warning` : `light`}
                                        style={{cursor: 'zoom-in'}} 
                                        onClick={e => this.props.setSelectedEdition(this.state.offersOverviewData[k].editionId)}>
                                        <Card.Header as="h5">
                                          Offer # {this.state.offersOverviewData[k].offer.id}: {projects[projectId-1].name} # {this.state.offersOverviewData[k].editionId}
                                        </Card.Header>
                                        <Card.Body>
                                        <Card.Subtitle className="mb-2 text-muted" >
                                          Maker:
                                        </Card.Subtitle>
                                        <Card.Title>
                                          <EnsResolver lookup={this.state.offersOverviewData[k].offer.offer[0]}/>&nbsp;
                                          <span className="mb-2 text-muted" style={{fontSize: 'xx-small'}}>({this.state.offersOverviewData[k].offer.offer[0]})</span>
                                        </Card.Title>
                                        <Card.Subtitle className="mb-2 text-muted" >
                                        Offered Amount:
                                        </Card.Subtitle>
                                        <Card.Title>
                                        {Web3.utils.fromWei(this.state.offersOverviewData[k].offer.offer[3], "ether")}&nbsp;
                                          <ERC20Resolver 
                                            key={`OffersOverviewERC20TokenResolverShort-${this.state.offersOverviewData[k].offer.id}`} 
                                            tokenAddress={this.state.offersOverviewData[k].offer.offer[1]}
                                            short={true}
                                          />
                                        </Card.Title>
                                        </Card.Body>
                                      </Card>
                                  ))) : (
                                    <Card>
                                        <Card.Body>
                                        <Card.Title>
                                          {this.state.zoraLoadError ? 'Could not read offers' : 'No Current Offers'}
                                        </Card.Title>
                                        </Card.Body>
                                      </Card>
                                  )
                              }
                              </CardColumns>
                            </Card.Body>
                          </Card>
    </Tab>
    const overviewAuctionsTab = <Tab eventKey="zora_auctions_overview" title="Auctions">
      <p></p>
                          <Card>
                            <Card.Body>
                              <Card.Title>
                                Auctions Overview
                              </Card.Title>
                                <CardColumns>
                              {
                                (this.state.auctionsOverviewData && !(Object.keys(this.state.auctionsOverviewData).length === 0)) ? (
                                  Object.keys(this.state.auctionsOverviewData).map((k,i) =>(
                                    
                                      <Card key={i}
                                        bg={(this.props.account === this.state.auctionsOverviewData[k].auction.auction[0]) ? `warning` : `light`}
                                        style={{cursor: 'zoom-in'}} onClick={e => this.props.setSelectedEdition(this.state.auctionsOverviewData[k].editionId)}>
                                        <Card.Header as="h5">
                                          {projects[projectId-1].name} # {this.state.auctionsOverviewData[k].editionId}
                                        </Card.Header>
                                        <Card.Body>
                                        <Card.Subtitle className="mb-2 text-muted" >
                                          Seller:
                                        </Card.Subtitle>
                                        <Card.Title>
                                          <EnsResolver lookup={this.state.auctionsOverviewData[k].auction.auction[0]}/>&nbsp;
                                          <span className="mb-2 text-muted" style={{fontSize: 'xx-small'}}>({this.state.auctionsOverviewData[k].auction.auction[0]})</span>
                                        </Card.Title>
                                        <Card.Subtitle className="mb-2 text-muted" >
                                        Reserve Price:
                                        </Card.Subtitle>
                                        <Card.Title>
                                        {Web3.utils.fromWei(this.state.auctionsOverviewData[k].auction.auction[1], "ether")}&nbsp;
                                          <ERC20Resolver 
                                            key={`AuctionsOverviewReserveERC20TokenResolverShort-${this.state.auctionsOverviewData[k].tokenId}`} 
                                            tokenAddress={this.state.auctionsOverviewData[k].auction.auction[7]}
                                            short={true}
                                          />
                                        </Card.Title>
                                        {(parseInt(this.state.auctionsOverviewData[k].auction.auction[3]) > 0) ? (
                                          <>
                                          <hr/>
                                          <Card.Subtitle className="mb-2 text-muted">
                                            Highest Bidder:
                                          </Card.Subtitle>
                                          <Card.Title>
                                            <EnsResolver lookup={this.state.auctionsOverviewData[k].auction.auction[4]}/>&nbsp;
                                            <span className="mb-2 text-muted" style={{fontSize: 'xx-small'}}>({this.state.auctionsOverviewData[k].auction.auction[4]})</span>
                                          </Card.Title>
                                          <Card.Subtitle className="mb-2 text-muted" >
                                          Highest Bid:
                                          </Card.Subtitle>
                                          <Card.Title>
                                          {Web3.utils.fromWei(this.state.auctionsOverviewData[k].auction.auction[3], "ether")}&nbsp;
                                            <ERC20Resolver 
                                              key={`AuctionsOverviewHighBidERC20TokenResolverShort-${this.state.auctionsOverviewData[k].tokenId}`} 
                                              tokenAddress={this.state.auctionsOverviewData[k].auction.auction[7]}
                                              short={true}
                                            />
                                          </Card.Title>
                                          </>
                                        ) : ("")}

                                        <hr/>
                                        <Card.Subtitle className="mb-2 text-muted">
                                          Time Left:
                                        </Card.Subtitle>
                                        <Card.Title>
                                          {(parseInt(this.state.auctionsOverviewData[k].auction.auction[8]) > 0) ? (
                                        <Countdown 
                                          date={(parseInt(this.state.auctionsOverviewData[k].auction.auction[8]) + parseInt(this.state.auctionsOverviewData[k].auction.auction[5]))*1000}>
                                            {<>Ready to Settle</>}
                                        </Countdown>
                                          ) : (<>Awaiting First Bid</>)}
                                        </Card.Title>
                                        </Card.Body>
                                      </Card>
                                  
                                  ))) : (
                                    <Card>
                                        <Card.Body>
                                        <Card.Title>
                                          {this.state.zoraLoadError ? 'Could not read auctions' : 'No Current Auctions'}
                                        </Card.Title>
                                        </Card.Body>
                                      </Card>
                                  )
                              }
                              </CardColumns>
                            </Card.Body>
                          </Card>
    </Tab>

    const overviewTab = <Tab eventKey="overview" title="Overview">
                        {(this.state.zoraLogsModalLoading) ? (
                            <>{loadingInsert}</>
                        ) : (
                          <>
                          <Tabs id="uncontrolled-tab-example">
                          <p></p>
                          {overviewAsksTab}
                          {overviewOffersTab}
                          {overviewAuctionsTab}
                          </Tabs>
                          </>
                        )}
                        </Tab>

    /// RENDER
    const panelFooter = (
      <>
          Etherscan:
          {((this.state.zoraAsks && showAsks) || !this.props.tokenId) ? (
          <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${this.state.zoraAsks.options.address}`)}>zora asks</Button>
          ) : ("")}
          {((this.state.zoraOffers && showOffers) || !this.props.tokenId) ? (
          <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${this.state.zoraOffers.options.address}`)}>zora offers</Button>
          ) : ("")}
          {((this.state.zoraAuctions && showAuctions) || !this.props.tokenId) ? (
          <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${this.state.zoraAuctions.options.address}`)}>zora auctions</Button>
          ) : ("")}
          {(this.state.zoraERC721TransferHelper && this.props.tokenId && this.props.account === this.props.ownerOfSelectedEdition) ? (
          <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${this.state.zoraERC721TransferHelper.options.address}`)}>zora erc721transferhelper</Button>
          ) : ("")}
          {(this.state.zoraERC20TransferHelper && this.props.tokenId && this.props.account !== this.props.ownerOfSelectedEdition) ? (
          <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${this.state.zoraERC20TransferHelper.options.address}`)}>zora erc20transferhelper</Button>
          ) : ("")}
          {(this.state.zoraModuleManager && this.props.tokenId) ? (
          <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${this.state.zoraModuleManager.address}`)}>zora modulemanager</Button>
          ) : ("")}
        {(contract && contract.options) ? (
          <>
          {(this.state.zoraModalLoading) ? (
            <Button variant="warning btn-sm" className="font-display" onClick={() => this.setState({zoraModalLoading: false})}>reset loading</Button>
          ) : ("")}
          {(this.props.tokenId) ? (
            <Button variant="info btn-sm" className="font-display" onClick={() => this.props.resetSelectedEdition()}>&lt; overview</Button>
          ) : ("")}
          <Button variant="outline-info btn-sm" className="font-display" onClick={() => this.updateAndNotify()}>reload data</Button>


          {projectTokens && projectTokens[editionId-1] && (
            <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_token_link}${contract.options.address}${platform.etherscan_token_query_after_contract}${projectTokens[editionId-1].tokenId}`)}>etherscan</Button>
          )}
          </>
        ) : ("")}
          <Button variant="secondary btn-sm"  className="font-display" onClick={closeZoraModal}> close </Button>
      </>
    );

    return (
      <DockPanel
        show={isZoraModalOpen}
        onClose={closeZoraModal}
        title={<>{modalTitle}</>}
        storageKey="zora"
        unstyled
        defaultWidth={980}
        defaultHeight={700}
        minWidth={360}
        minHeight={240}
        footer={panelFooter}
      >
        <div className="dock-panel__pad">
        <p></p>
            <Tabs id="uncontrolled-tab-example">
              {(!this.props.tokenId) ? overviewTab : `` }
              {(showAsks && this.props.tokenId) ? zoraAsksTab : ``}
              {(showOffers && this.props.tokenId) ? zoraOffersTab : ``}
              {(showAuctions && this.props.tokenId) ? zoraAuctionsTab : ``}
            </Tabs>

        </div>
      </DockPanel>
    );
  }
}

export default ZoraModal;
